import { render, staticRenderFns } from "./newsxq.vue?vue&type=template&id=24a474ba&scoped=true"
import script from "./newsxq.vue?vue&type=script&lang=js"
export * from "./newsxq.vue?vue&type=script&lang=js"
import style0 from "./newsxq.vue?vue&type=style&index=0&id=24a474ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a474ba",
  null
  
)

export default component.exports